define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"./_DropDownMenuPlugin",
	"./PluginFactory",
	"./util"
], function(array,lang,_DropDownMenuPlugin,PluginFactory,util) {

	return PluginFactory.declare([_DropDownMenuPlugin], {
		propertyKey: util.shapeProperties.strokeWidth,
		iconClass: "flipIconVertical",
		materialIcon: "line_weight",
		pluginName: "width",
		title: "CanvasLineWidth",

		// extension point called when user changes width
		onWidth: function() {},

		startup: function() {
			this.dropDown = this.createDropDownMenu([
				"svgIconStrokeWidth0",
				"svgIconStrokeWidth1",
				"svgIconStrokeWidth2",
				"svgIconStrokeWidth3",
				"svgIconStrokeWidth4"
	        ]);

			// need special logic to get and set width
			this.editor._attrGetters[this.cssStyle] = lang.hitch(this, this._getWidthAttr);
			this.editor._attrSetters[this.cssStyle] = lang.hitch(this, this._setWidthAttr);

			this.inherited(arguments);
		},

		onClickDropDown: function(/*Event*/e) {
			// summary: call onWidth extension point - cannot connect to onClickDropDown because Dojo stops event propagation?
			this.inherited(arguments);
			this.onWidth();
		},

		encode: function(value) {
			return util.widthStyles[Number(value)];
		},

		decode: function(value) {
			return array.indexOf(util.widthStyles, value);
		},

		getShapeAttrValue: function(shape) {
			return this._getWidthAttr(shape);
		},

		_getWidthAttr: function(/*Shape*/shape) {
			// summary: get attribute based on shape
			var	i = array.indexOf(util.widthStyles, shape.getShapeStyle(this.cssStyle));
			return (i > 0) ? i : 0;
		},

		_setWidthAttr: function(/*Shape*/shape, /*String*/value, /*Object?*/attrs) {
			// summary: set attribute based on menu item index
			if (!shape.getShapeLock()) {
				shape.setShapeStyle(this.cssStyle, util.widthStyles[Number(value)]);
			}

			this.editor.canvasApp.pageApi().setStrokeWidth(Number(value));
		}
	});
});